import { useMutation, useQueryClient } from '@tanstack/react-query';
import { produce } from 'immer';
import type { RespondedType, ResponseError } from '@/models/response';
import { addTranslateToast } from '@/stores/toast';
import { fetcher } from '@/utils/fetcher';
import { tagListQueryOptions } from './use-tags';

export default function useDeleteTags() {
  const queryClient = useQueryClient();

  return useMutation<RespondedType, ResponseError, number[]>({
    mutationFn: (tagIds) => fetcher('/DeleteTags', { TagIds: tagIds }, { validResponseCodes: [0] }),
    onSuccess: (_, params) => {
      addTranslateToast({
        type: 'success',
        message: 'common.delete-success',
      });

      queryClient.setQueryData(tagListQueryOptions.queryKey, (state) =>
        produce(state, (draft) => {
          if (!draft?.Data) return draft;

          draft.Data.Tags = draft.Data.Tags.filter((tag) => !params.includes(tag.Id));
        }),
      );
    },
  });
}
